import API from "../Services/API";
import Model from "./Model";

const useSettings = (path, savedMessage, params) => {
    return Model({
        alwaysRefresh: true,
        stateKey: ['settings', path, params],
        fetchData: () => API.get(path, params),
        returnDataKey: 'settings',
        registerAdditionalMethods: (opts) => {
            return {
                update: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post(path, {...data, ...(params ?? {})}),
                        savedMessage ?? 'Settings saved',
                        true,
                    );
                }
            }
        },
        defaultLoadingError: 'Failed to load settings.',
    });
}

const customerNotificationSettings = [
    'Notifications:SendCustomerJobBecameToday',
    'Notifications:SendCustomerJobBecameTomorrow',
    'Notifications:SendCustomerJobDueWeekUpdated',
    'Notifications:SendCustomerJobMarkedAsDone',
    'Notifications:SendCustomerJobSkipped',
    'Notifications:SendCustomerJobScheduled',
    'Notifications:SendCustomerMessageSent',
    'Notifications:SendCustomerInvoiceBecameOverdue',
    'Notifications:SendCustomerWelcome',
    'Notifications:SendCustomerPortalLink',
];

const quoteNotificationSettings = [
    'Notifications:SendQuoteRequested',
    'Notifications:SendQuoteMessageSent',
    'Notifications:SendQuoteEstimated',
    'Notifications:SendQuoteItemised',
];

export {
    useSettings,
    customerNotificationSettings,
    quoteNotificationSettings,
}